import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Unstable_Grid2";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import SALE_TYPES from "../../dictionaries/saleTypes.json";
import {
  cancelEdit,
  isValidSale,
  save,
  selectors as airSalesSelectors,
  selectAirSaleEditOpen,
  selectEditedAirSaleId,
  selectAirSaleIsSaving,
} from "../../redux/sales";
import ModalScreen from "../ModalScreen";
import SaleTypeIndicator from "../SaleTypeIndicator";
import EditAirSaleForm from "./EditAirSaleForm";
import EditCruiseSaleForm from "./EditCruiseSaleForm";
import EditHotelSaleForm from "./EditHotelSaleForm";
import EditOtherSaleForm from "./EditOtherSaleForm";

const SALE_FORMS_BY_TYPE = {
  CR: EditCruiseSaleForm,
  CS: EditCruiseSaleForm,
  ER: EditAirSaleForm,
  ES: EditAirSaleForm,
  HR: EditHotelSaleForm,
  HS: EditHotelSaleForm,
  TR: EditAirSaleForm,
  TS: EditAirSaleForm,
  TX: EditAirSaleForm,
  OR: EditOtherSaleForm,
  OS: EditOtherSaleForm,
};

const saleTypeOptions = [
  "Ticket",
  "TS",
  "TR",
  "TX",
  "ES",
  "ER",
  "Hotel",
  "HS",
  "HR",
  "Cruise",
  "CS",
  "CR",
  "Other",
  "OS",
  "OR",
].map((key) => SALE_TYPES[key] || key);

const defaultSaleType = "TS";

const EditSale = (props) => {
  const dispatch = useDispatch();

  const existingSale = useSelector((state) =>
    airSalesSelectors.selectById(state, selectEditedAirSaleId(state)),
  );

  const isExistingSale = !!existingSale;

  const isSaving = useSelector(selectAirSaleIsSaving);

  const [saleChanges, setSaleChanges] = useState(null);
  const [saleType, setSaleType] = useState(defaultSaleType);

  const open = useSelector(selectAirSaleEditOpen);

  useEffect(() => {
    setSaleChanges(null);
    setSaleType(defaultSaleType);
  }, [open]);

  const sale = existingSale || { ...saleChanges, type: saleType };

  const saleTypeObj = SALE_TYPES[sale.type];

  const EditSaleForm = SALE_FORMS_BY_TYPE[sale.type];

  const isRefund = saleTypeObj.isRefund;
  const formTitle = saleTypeObj.name;

  const saleToSave = saleChanges || sale;

  const isValid = isValidSale(saleToSave);

  const onClose = () => {
    dispatch(cancelEdit());
  };

  const onSaleTypeChange = (event) => {
    const saleType = event.target.value;
    setSaleType(saleType);
    setSaleChanges(null);
  };

  const onSave = (event) => {
    dispatch(save(saleToSave));
  };

  const title = isExistingSale ? "Edit Sale" : "Add New Sale";

  return (
    <ModalScreen open={open} onClose={onClose} title={title}>
      <Grid container spacing={2} sx={{ overflowX: "hidden" }}>
        <Grid xs={12}>
          <TextField
            fullWidth
            label="Sale Type"
            onChange={onSaleTypeChange}
            select
            disabled={isExistingSale}
            value={sale.type}
          >
            {saleTypeOptions.map((option) =>
              !option.id ? (
                <Divider
                  key={`edit-sale-divider-${option}`}
                  sx={{ fontSize: "14px", marginBottom: "0px !important" }}
                  textAlign="left"
                >
                  {option}
                </Divider>
              ) : (
                <MenuItem
                  key={`EditSale-SaleType-${option.id}`}
                  value={option.id}
                >
                  <SaleTypeIndicator
                    disabled={isExistingSale}
                    sx={{ marginRight: "7px" }}
                    value={option.id}
                  />
                  <span>{option.name}</span>
                </MenuItem>
              ),
            )}
          </TextField>
        </Grid>
        <Grid xs={12}>
          {EditSaleForm && (
            <EditSaleForm
              isRefund={isRefund}
              onChange={setSaleChanges}
              sale={saleToSave}
              title={formTitle}
            />
          )}
        </Grid>
        <Grid xs={12}>
          <Button
            className={isSaving ? "InProgress" : ""}
            fullWidth
            disabled={!isValid || isSaving}
            onClick={onSave}
          >
            {isSaving ? "Saving..." : "Save"}
          </Button>
        </Grid>
      </Grid>
    </ModalScreen>
  );
};

export default EditSale;
